<template>
  <div>
    <p class="notification">
      Actions are where you define what should be done when there is a policy
      violation.
    </p>
    

    <Visibility
      @emitData="getValue($event, 'visibility')"
      :visibility="actionsObj.visibility"
    />
    <ApprovalLevel
      @emitData="getValue($event, 'approvalLevel')"
      :approvalLevel="actionsObj.approvalLevel"
    />
    <Notification
      @emitData="getValue($event, 'notification')"
      :notifications="actionsObj.notifications"
    />
  </div>
</template>
<script>
import ApprovalLevel from "../ActionComponent/ApprovalLevel.vue";
import Visibility from "../ActionComponent/Visibility";
import Notification from "../notifications/Notification.vue";
export default {
  name: "Actions",
  props: {
    notifications: {
      type: [Object],
    },
    visibility: String,
    approvalLevel: String,
    travelPolicy: {
      type: [Object],
    },
  },
  components: {
    ApprovalLevel,
    Visibility,
    Notification,
  },
  data() {
    return {
      actionsObj: {
        visibility: 'show',
        approvalLevel: 'hard',
        notifications: {},
      },
    };
  },
  methods: {
    getValue(val, source) {

      if (source == "visibility") {
        this.actionsObj.visibility = val.visibility;
      } else if (source == "approvalLevel") {
        this.actionsObj.approvalLevel = val.approvalLevel;
      } else {
        // this.actionsObj.notifications.push(val)
        this.actionsObj.notifications = val;
      }
      this.$emit("actionsData", this.actionsObj);
    },
  },
  mounted() {
  //  this.$emit("actionsData", this.actionsObj);
  },
  watch: {
    travelPolicy: {
      handler(newVal, prevVal) {
          if (newVal.simplePolicyConfig) {
          var jsonData = newVal.simplePolicyConfig;
          this.actionsObj.visibility = jsonData.visibility;
          this.actionsObj.approvalLevel = jsonData.approvalLevel;
          this.actionsObj.notifications = jsonData.notifications;
          this.$emit("actionsData", this.actionsObj);
        }
           
      },
      deep: true,
    },
    approvalLevel: {
      handler(newVal, prevVal) {
        this.actionsObj.approvalLevel = newVal;
       this.$emit("actionsData", this.actionsObj);
      },
      deep: false,
    },
    visibility: {
      handler(newVal, prevVal) {
        this.actionsObj.visibility = newVal;
        this.$emit("actionsData", this.actionsObj);
      },
      deep: false,
    },
    notifications: {
      handler(newVal, prevVal) {
        this.actionsObj.notifications = newVal;
        this.$emit("actionsData", this.actionsObj);
      },
      deep: true,
    },
  },
};
</script>
